module.exports = __webpack_public_path__ + "img/18_58.12447f27.png";